/**
 * Sunday Gunner: more damage, unconditionally.
 *
 * The seed instance for the `damageModifiers` channel. One modifier per rank is pushed into the
 * pipeline's stage three, which is the seam `damageResolution.ts` has been carrying an empty list
 * for since the combat model landed.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const SUNDAY_GUNNER = {
  id: 'sundayGunner',
  branch: 'gunplay',
  tier: 1,
  title: 'Sunday Gunner',
  blurb: 'Weekend range time, back when weekends were a thing and the range was for paper.',
  maxRanks: 3,
  minLevel: 3,
  requires: [],
  statGrants: {},
  effects: [],
  damageModifiers: [{ source: 'sundayGunner', flat: 0, scale: 1.05 }],
} as const satisfies Perk;
